import { render, staticRenderFns } from "./PrivacyStatement.vue?vue&type=template&id=09372db8&"
import script from "./PrivacyStatement.vue?vue&type=script&lang=js&"
export * from "./PrivacyStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports